var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DataList',{attrs:{"title":"Виконавці","resource":"employees","columns":_vm.columns,"disable-adding":true,"get-items-fn":_vm.getEmployees,"search-label":'Пошук за ПІБ'}})}
var staticRenderFns = []

export { render, staticRenderFns }